import {
  WSList,
  WSPanel,
  WSSectionToolbar
} from "@wingspanhq/fe-component-library";
import {
  PayeeRequirement,
  RequirementStatus
} from "@wingspanhq/wingspan-api-sdk";
import React from "react";

import { StepItem, Steps } from "../../../shared/components/Steps";
import { selectorIsRequirementPostApproval } from "../selectors/selectorIsRequirementPostApproval";

export const getRequirementProgressWidget = (
  steps: StepItem[] | undefined,
  requirement: PayeeRequirement,
  showTitle: boolean = true
) => {
  if (!steps?.length) {
    return null;
  }

  let extendedSteps = steps;

  const isPostApprovalFlow = selectorIsRequirementPostApproval(requirement);

  const isPendingPayerReview =
    requirement.status === RequirementStatus.PENDING_PAYER_REVIEW;

  // The v1 instance carried `reviewStrategy` (AlwaysRequired/OnFail) and the
  // widget branched on it statically. The v3 instance no longer exposes the
  // strategy (it is definition-level `reviewPolicy`), so the approval step is
  // injected from the instance's own review signals instead: the requirement
  // is either awaiting payer review now, or has already been reviewed.
  if (isPendingPayerReview || isPostApprovalFlow) {
    const completeStep = steps[steps.length - 1]; // Complete step is always the last step

    // Inject the approval status into the steps before the Complete step
    extendedSteps = [
      ...steps.slice(0, -1),
      {
        title: "Approval",
        status: isPendingPayerReview
          ? "Active"
          : requirement.status === RequirementStatus.COMPLETED
            ? "Complete"
            : "Rejected"
      },
      {
        ...completeStep,
        status:
          requirement.status === RequirementStatus.COMPLETED
            ? "Complete"
            : "Pending"
      }
    ];
  }

  return (
    <WSList gap="S">
      {showTitle && <WSSectionToolbar title="Requirement steps" />}
      <WSPanel mt="S">
        <Steps steps={extendedSteps} />
      </WSPanel>
    </WSList>
  );
};
